import { AvailableChildrenType, SugarElementInfo } from "../../SugarElementInfo";

export const br: SugarElementInfo = { name: "br", availableChildren: { type: AvailableChildrenType.NoChildren } };
